import { Routes, Route } from "react-router-dom";
import MainPage from "./MainPage";
import FrameOverlay from "./FrameOverlay";
import TopNav from "./TopNav";
import FeedbackAnalysis from "./FeedbackAnalysis";
import ProperOnboarding from "./ProperOnboarding";
import CreditBuilder from "./CreditBuilder";
import SkipButtonStory from "./SkipButtonStory";
import BIMIndustry from "./BIMIndustry";
import SolibriPlugin from "./SolibriPlugin";
import SolibriEditor from "./SolibriEditor";
import { useState } from "react";
import Menu from "./Menu";
import DesignSystem from "./DesignSystem";
import MobileView from "./MobileView";
import { useWindowSize } from "./utils";
import ChatBot from "./ChatBot";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const openMenu = () => setIsMenuOpen(true);
  const closeMenu = () => setIsMenuOpen(false);
  const { width } = useWindowSize();
  const isMobile = width < 900;

  if (isMobile) {
    return <MobileView />;
  }

  return (
    <>
      <Menu closeMenu={closeMenu} isMenuOpen={isMenuOpen} />
      {!isMenuOpen && (
        <>
          <TopNav openMenu={openMenu} />
          <FrameOverlay />
        </>
      )}
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/case1" element={<BIMIndustry />} />
        <Route path="/case1/plugin" element={<SolibriPlugin />} />
        <Route path="/case1/editor" element={<SolibriEditor />} />
        <Route path="/case1/designsystem" element={<DesignSystem />} />
        <Route path="/case2" element={<FeedbackAnalysis />} />
        <Route path="/case3" element={<ProperOnboarding />} />
        <Route path="/case3.1." element={<SkipButtonStory />} />
        <Route path="/case3.2." element={<ChatBot />} />
        <Route path="/case4" element={<CreditBuilder />} />
      </Routes>
    </>
  );
}

export default App;
